export default __webpack_public_path__ + "public/assets/images/6bff677ae2e5f2ac3d7fc477c115d9ee.png";